// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 657 ? "93b25bb5" : chunkId) + "." + {"657":"e47feed85c298271","789":"74637ef67f81a96d"}[chunkId] + ".js";
};